(() => {
  'use strict';
  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD', minimumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (_) { return `$${((Number(cents) || 0) / 100).toFixed(2)}`; }
  };

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const sectionId = root.dataset.sectionId;
    const productInfo = root.closest('product-info');
    if (productInfo) productInfo.classList.add('vt-v101-product');
    const section = root.closest('.shopify-section') || document;

    // V67: force the real quantity selector and Add to Cart button into the
    // exact same horizontal row, even when the Varethorn theme setting renders
    // quantity as a separate block above the buy-buttons snippet.
    const atcRow = productInfo?.querySelector('.product-form__quantity-and-btn');
    const qtyBlock = productInfo?.querySelector('.product-form__quantity');
    const atcButton = atcRow?.querySelector('.product-form__submit, button[name="add"]');
    if (atcRow && qtyBlock && atcButton && qtyBlock.parentElement !== atcRow) {
      atcRow.insertBefore(qtyBlock, atcButton);
    }
    if (atcRow) atcRow.classList.add('vt-v101-exact-atc-row');
    const buttons = [...root.querySelectorAll('[data-variant-id]')];
    const currency = window.Shopify?.currency?.active || 'USD';
    const findFormInputs = () => [...document.querySelectorAll(`form[id*="product-form-${sectionId}"] input[name="id"], #product-form-${sectionId} input[name="id"]`)];

    function updateVisiblePrices(button) {
      const price = Number(button.dataset.price || 0);
      const compare = Number(button.dataset.compare || 0);
      const priceRoot = productInfo?.querySelector(`#price-${sectionId}`) || productInfo?.querySelector('.product-page-price');
      if (priceRoot) {
        priceRoot.querySelectorAll('.price-item--regular, .price-item--sale').forEach((node, index) => {
          if (index === 0 || node.classList.contains('price-item--sale')) node.textContent = formatMoney(price, currency);
        });
        priceRoot.querySelectorAll('s.price-item--regular, .price__compare .price-item').forEach(node => {
          node.textContent = compare > price ? formatMoney(compare, currency) : '';
        });
      }
      document.querySelectorAll('.sticky-atc__price .price-item--regular, .sticky-atc__price .price-item--sale').forEach((node, index) => {
        if (index === 0 || node.classList.contains('price-item--sale')) node.textContent = formatMoney(price, currency);
      });
    }

    function syncAtcLabel(button) {
      const price = formatMoney(Number(button.dataset.price || 0), currency);
      section.querySelectorAll('button[name="add"], .product-form__submit').forEach(btn => {
        const available = button.dataset.available === 'true';
        btn.disabled = !available;
        const textNode = btn.querySelector('.main-atc__label__text');
        const labelWrap = btn.querySelector('.main-atc__label');
        let priceNode = btn.querySelector('.main-atc-price, .vt-v101-created-price');
        if (labelWrap) {
          labelWrap.classList.add('vt-v101-atc-label');
          if (!priceNode) {
            priceNode = document.createElement('span');
            priceNode.className = 'main-atc-price vt-v101-created-price';
            labelWrap.appendChild(priceNode);
          }
        }
        if (textNode) textNode.textContent = available ? 'Add to cart' : 'Sold out';
        if (priceNode) {
          priceNode.classList.toggle('hidden', !available);
          priceNode.textContent = available ? `• ${price}` : '';
        }
        if (!textNode && !labelWrap) btn.textContent = available ? `Add to cart • ${price}` : 'Sold out';
      });
    }

    function syncInstallments(button) {
      const line = productInfo?.querySelector('[data-vt-installments-line]') || section.querySelector('[data-vt-installments-line]');
      const copy = line?.querySelector('[data-vt-installments-copy]');
      if (!line || !copy) return;
      const threshold = Number(line.dataset.thresholdCents || 3500);
      const priceCents = Number(button.dataset.price || 0);
      if (priceCents >= threshold) {
        const installment = formatMoney(priceCents / 4, currency);
        copy.innerHTML = `Pay in 4 interest-free installments of <strong data-vt-installments-amount>${installment}</strong> with <span class="varethorn-installments-shop-pay" aria-label="Shop Pay"><span class="varethorn-installments-shop-pay__word">shop</span><span class="varethorn-installments-shop-pay__badge">Pay</span></span>.`;
      } else {
        copy.innerHTML = `Shop Pay installments available on orders over <strong data-vt-installments-threshold>${formatMoney(threshold, currency)}</strong>.`;
      }
    }

    function select(button) {
      if (!button) return;
      buttons.forEach(btn => {
        const active = btn === button;
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      const id = button.dataset.variantId;
      findFormInputs().forEach(input => {
        input.value = id;
        input.setAttribute('value', id);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      updateVisiblePrices(button);
      syncAtcLabel(button);
      syncInstallments(button);
      root.dataset.selectedQty = button.dataset.qty || '5';
      try { history.replaceState({}, '', window.location.pathname); } catch (_) {}
    }

    buttons.forEach(button => button.addEventListener('click', () => select(button)));
    const initial = buttons.find(btn => btn.dataset.qty === '5') || buttons[0];
    select(initial);
  }

  const boot = () => document.querySelectorAll('[data-vt-pack-selector]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
})();
